import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqyTotSttsStore', Object.keys(getters)),
	...mapState('pqyTotSttsStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqyTotSttsStore', Object.keys(actions)),
	...mapMutations('pqyTotSttsStore', Object.keys(mutations))
};
